import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useContext } from 'react';
import { ScopedProviderContext } from './index';
class ScopedStoreNotFoundError extends Error {
    constructor() {
        super('No scoped store found');
    }
}
export const useScopedAtom = ((atom, options) => {
    const scopedProviderContext = useContext(ScopedProviderContext);
    const scopedStore = scopedProviderContext.get(atom);
    if (!scopedStore) {
        throw new ScopedStoreNotFoundError();
    }
    return useAtom(atom, { store: scopedStore, ...options });
});
export const useScopedAtomValue = (atom, options) => {
    const scopedProviderContext = useContext(ScopedProviderContext);
    const scopedStore = scopedProviderContext.get(atom);
    if (!scopedStore) {
        throw new ScopedStoreNotFoundError();
    }
    return useAtomValue(atom, { store: scopedStore, ...options });
};
export const useSetScopedAtom = (atom, options) => {
    const scopedProviderContext = useContext(ScopedProviderContext);
    const scopedStore = scopedProviderContext.get(atom);
    if (!scopedStore) {
        throw new ScopedStoreNotFoundError();
    }
    return useSetAtom(atom, { store: scopedStore, ...options });
};
